import React from "react";
import {Form, Input, Modal} from "antd";
import {FormModalProps} from "../../../../utils/useFormModal";

function ModifyModal(props: FormModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item label={'编号'} name={'code'} rules={[{required: true, message: '请输入编号'}]}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'名称'} name={'name'} rules={[{required: true, message: '请输入名称'}]}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ModifyModal
